<template>
  <DynamicForm
    dynamicFormType="fundoscopy"
    :answerableId="attendance.id"
    answerableType="Attendance"
    :disabled=true
  />
</template>

<script>
import DynamicForm from "@/components/dynamic_form/index.vue";

  export default {
    name: "Fundoscopy",
    components: {
      DynamicForm,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
  };
</script>

<style lang="scss" scoped></style>
